'use strict';

(function ($, Drupal) {

  /**
   * Get anchor value and show on modal.
   *
   * @type {{attach: attach}}
   */
  Drupal.behaviors.anchorPages = {
    attach: function attach(context) {

      // Get URL and add anchor.
      $('.container', context).on('click', '.share', function () {
        const target = $(this).closest('[data-anchor]');
        const anchor = target.data('anchor');

        const domainSite = document.domain;
        const pathname = window.location.pathname;

        // Add URL in input modal.
        const urlShare = `https://${domainSite}${pathname}#${anchor}`;
        $('#input-anchor').val(urlShare);
      });

      // Select and copy URL from modal.
      $('.modal-share').on('click', '.modal-anchor-copy', () => {
        const text = $('.input-anchor-modal').val();
        document.getElementById("input-anchor").select();
        document.execCommand('copy');
      });
    }
  };


})(jQuery, Drupal);
